import {isFeatureEnabled} from '@github-ui/feature-flags'
import {
  BulkIssueIssueTypePicker as BulkIssueIssueTypePickerFuture,
  DefaultIssueTypeAnchor as DefaultIssueTypeAnchorFuture,
  DefaultIssueTypePickerFooterAnchor as DefaultIssueTypePickerFooterAnchorFuture,
  fetchIssueTypes as fetchIssueTypesFuture,
  IssueTypePicker as IssueTypePickerFuture,
  IssueTypePickerGraphqlSharedQuery as IssueTypePickerGraphqlQueryFuture,
  type IssueTypePickerIssueType as IssueTypePickerIssueTypeFuture,
  type IssueTypePickerIssueTypeSharedKey,
  type IssueTypePickerTestSharedQueries,
  readIssueTypeFromFragment as readIssueTypeFromFragmentFuture,
  UNSET_ID as UNSET_IDFuture,
} from '@github-ui/item-picker-issue-type-relay'
import type {Environment} from 'react-relay'

import type {IssueTypePickerIssueType$key} from './__generated__/IssueTypePickerIssueType.graphql'
import {
  BulkIssueIssueTypePicker as LegacyBulkIssueIssueTypePicker,
  type BulkIssueIssueTypePickerProps,
  DefaultIssueTypeAnchor as LegacyDefaultIssueTypeAnchor,
  type DefaultIssueTypeAnchorProps,
  DefaultIssueTypePickerFooterAnchor as LegacyDefaultIssueTypePickerFooterAnchor,
  fetchIssueTypes as fetchIssueTypesLegacy,
  IssueTypePicker as LegacyIssueTypePicker,
  type IssueTypePickerProps,
  readIssueTypeFromFragment as readIssueTypeFromFragmentLegacy,
} from './IssueTypePicker'

export type IssueTypePickerIssueType = IssueTypePickerIssueTypeFuture
export type IssueTypePickerTestQueries = IssueTypePickerTestSharedQueries
export const IssueTypePickerGraphqlQuery = IssueTypePickerGraphqlQueryFuture
export const UNSET_ID = UNSET_IDFuture

export function IssueTypePicker(props: IssueTypePickerProps) {
  const ffEnabled = isFeatureEnabled('item_picker_issue_type_relay_migration')
  return ffEnabled ? <IssueTypePickerFuture {...props} /> : <LegacyIssueTypePicker {...props} />
}

export function BulkIssueIssueTypePicker(props: BulkIssueIssueTypePickerProps) {
  const ffEnabled = isFeatureEnabled('item_picker_issue_type_relay_migration')
  return ffEnabled ? <BulkIssueIssueTypePickerFuture {...props} /> : <LegacyBulkIssueIssueTypePicker {...props} />
}

export function DefaultIssueTypeAnchor(props: DefaultIssueTypeAnchorProps) {
  const ffEnabled = isFeatureEnabled('item_picker_issue_type_relay_migration')
  return ffEnabled ? <DefaultIssueTypeAnchorFuture {...props} /> : <LegacyDefaultIssueTypeAnchor {...props} />
}

export function DefaultIssueTypePickerFooterAnchor(props: DefaultIssueTypeAnchorProps) {
  const ffEnabled = isFeatureEnabled('item_picker_issue_type_relay_migration')
  return ffEnabled ? (
    <DefaultIssueTypePickerFooterAnchorFuture {...props} />
  ) : (
    <LegacyDefaultIssueTypePickerFooterAnchor {...props} />
  )
}

export function readIssueTypeFromFragment(
  key: IssueTypePickerIssueType$key | IssueTypePickerIssueTypeSharedKey,
): IssueTypePickerIssueType {
  const ffEnabled = isFeatureEnabled('item_picker_issue_type_relay_migration')
  return ffEnabled
    ? readIssueTypeFromFragmentFuture(key as IssueTypePickerIssueTypeSharedKey)
    : readIssueTypeFromFragmentLegacy(key as IssueTypePickerIssueType$key)
}

export function fetchIssueTypes(
  environment: Environment,
  options: {
    owner: string
    repo: string
    pageSize: number
  },
) {
  const ffEnabled = isFeatureEnabled('item_picker_issue_type_relay_migration')
  return ffEnabled ? fetchIssueTypesFuture(environment, options) : fetchIssueTypesLegacy(environment, options)
}

try{ IssueTypePicker.displayName ||= 'IssueTypePicker' } catch {}
try{ BulkIssueIssueTypePicker.displayName ||= 'BulkIssueIssueTypePicker' } catch {}
try{ DefaultIssueTypeAnchor.displayName ||= 'DefaultIssueTypeAnchor' } catch {}
try{ DefaultIssueTypePickerFooterAnchor.displayName ||= 'DefaultIssueTypePickerFooterAnchor' } catch {}